export enum AnalysisAssuranceEnum {
  complete = 'COMPLETE',
  simple = 'SIMPLE'
}
